import React from "react";
import { Helmet } from "react-helmet-async";

const Contact = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#111111] text-[#f1f1f1] font-roboto">
      <Helmet>
        <title>Contact SeguraTech | Security Installations in Sussex</title>
        <meta
          name="description"
          content="Contact SeguraTech to discuss home security and alarm installations across Sussex. Clear advice, local service, and professional support."
        />
      </Helmet>

      <div className="bg-[#1a1a1a] border border-[#C6A564] rounded-2xl shadow-xl shadow-black/40 p-10 max-w-md w-full text-center animate-fadeIn">
        <img
          src="/SeguraTechLogo.png"
          alt="SeguraTech security company logo"
          className="mx-auto mb-6 w-44"
        />

        <h1 className="text-2xl font-semibold mb-4 text-[#C6A564]">
          Contact SeguraTech
        </h1>

        {/* Registered Office */}
        <p className="text-sm text-white/60 mb-1">Registered Office</p>
        <p className="mb-1">128 City Road</p>
        <p className="mb-1">London, EC1V 2NX</p>
        <p className="mb-4">United Kingdom</p>

        {/* Local Address */}
        <p className="text-sm text-white/60 mb-1">Local Address</p>
        <p className="mb-1">78 Reigate Road</p>
        <p className="mb-1">Worthing</p>
        <p className="mb-4">BN11 5NE</p>

        {/* Contact details */}
        <p className="mb-1">
          📞{" "}
          <a
            href="tel:07494184775"
            className="text-[#C6A564] hover:underline"
          >
            07494 184775
          </a>
        </p>

        <p className="mb-3">
          📧{" "}
          <a
            href="mailto:info@seguratech.co.uk"
            className="text-[#C6A564] hover:underline"
          >
            info@seguratech.co.uk
          </a>
        </p>

        <p className="mb-6 text-sm">Company No. 16754764</p>

        <p className="italic text-[#C6A564] text-sm">
          “Every message matters, because every client’s security does.”
        </p>
      </div>
    </div>
  );
};

export default Contact;
